export default 'M12 16.25a4.25 4.25 0 1 1 0-8.5 4.25 4.25 0 0 1 0 8.5M12 0 1.5 6v12L12 24l10.5-6V6z';